"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyControls = exports.Visibility = void 0;
/**
 * Visibility Enum for Content Privacy System
 * Controls whether individual patterns/projects are discoverable
 */
var Visibility;
(function (Visibility) {
    Visibility["PUBLIC"] = "public";
    Visibility["PRIVATE"] = "private";
    Visibility["ARCHIVED"] = "archived";
})(Visibility || (exports.Visibility = Visibility = {}));
/**
 * Privacy Controls Enum for Profile/Craft Room Settings
 * Controls what sections are visible on user profiles/craft rooms
 * NOTE: Does NOT bulk-update individual content visibility
 */
var PrivacyControls;
(function (PrivacyControls) {
    PrivacyControls["PUBLIC"] = "public";
    PrivacyControls["PRIVATE"] = "private";
})(PrivacyControls || (exports.PrivacyControls = PrivacyControls = {}));
